import { useQuery } from '@tanstack/react-query';
import { membersApi } from '../api/members';
import { MemberDetailDto } from '../types';

export function useMemberDetail(userId: string | null) {
  return useQuery<MemberDetailDto, Error>({
    queryKey: ['members', userId],
    queryFn: () => membersApi.getById(userId!),
    enabled: !!userId,
  });
}
